"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function QuestionFileUpload24Svg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 30, height: 24, viewBox: "0 0 30 24" }, props),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { id: `questionfileupload24-${id0}`, d: "M14.906 10.612L18.2 13.68l-.924.884-1.712-1.579v5.532h-1.317v-5.532l-1.712 1.579-.923-.884 3.294-3.07zM16.23 6c2.446 0 4.437 1.929 4.437 4.335 1.262.455 2.145 1.635 2.145 3.003 0 1.774-1.476 3.203-3.286 3.203h-1.04v-1.317h1.04c1.091 0 1.968-.85 1.968-1.886 0-.917-.69-1.7-1.631-1.856l-.637-.106.093-.639c.02-.141.03-.28.03-.418 0-1.653-1.391-3.001-3.12-3.001-1.145 0-2.178.598-2.725 1.541l-.294.506-.536-.23c-.253-.11-.525-.167-.804-.167-1.092 0-1.969.85-1.969 1.886 0 .234.046.463.135.682l.31.762-.811.136c-.703.118-1.217.702-1.217 1.383 0 .772.655 1.407 1.473 1.407h1.917v1.317H9.79C8.254 16.541 7 15.326 7 13.817c0-1.09.659-2.04 1.623-2.473-.026-.16-.04-.325-.04-.49 0-1.774 1.476-3.203 3.287-3.203.27 0 .537.032.796.095C13.49 6.663 14.802 6 16.23 6z" })),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { fill: "#F6F7F8", d: "M0 2.005C0 .898.898 0 1.992 0h26.016C29.108 0 30 .897 30 2.005v19.99C30 23.102 29.102 24 28.008 24H1.992C.892 24 0 23.103 0 21.995V2.005z" }),
            react_1.default.createElement("rect", { width: 24, height: 18, x: 3, y: 3, fill: "#CDD8FF", fillRule: "nonzero", rx: 1 }),
            react_1.default.createElement("use", { fill: "#698AFF", fillRule: "nonzero", xlinkHref: `#questionfileupload24-${id0}` })));
}
function QuestionFileUpload24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(QuestionFileUpload24Svg, Object.assign({}, svgProps)));
}
exports.default = QuestionFileUpload24;
//# sourceMappingURL=QuestionFileUpload24.js.map